import { render, staticRenderFns } from "./CommunityCompanySanjae.vue?vue&type=template&id=dae0487a&scoped=true"
import script from "./CommunityCompanySanjae.vue?vue&type=script&lang=js"
export * from "./CommunityCompanySanjae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae0487a",
  null
  
)

export default component.exports